module.exports = __webpack_public_path__ + "img/background.8bc827fb.png";